import VelocityScan from './VelocityScan'

export default VelocityScan